import styled from "styled-components";

const ContainerDetailStats = styled.div`
  margin: 0 auto 50px auto;
  width: 90%;
  max-width: 900px;
  padding-top: 20px;
`;

export default ContainerDetailStats;
